import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {AbstractAdvTechService} from "../../../../shared/services/advtech/abstract-advtech.service";

/**
 * Handles the Image Form data request
 * @class
 * @extends {AbstractAdvTechService}
 */
@Injectable()
export class ImageFormService extends AbstractAdvTechService {

  /**
   * Prefix for the url
   * @type {string}
   * @protected
   */
  protected prefix: string = 'mobile/content';

  /**
   * Call the image route and pass the finished image form in
   * @param {object} formData The formData being sent to the server
   * @param {string} id The id of each image being sent
   * @returns {Observable<any>}
   */
  sendCompletedImage(formData, id): Observable<any> {
    this.setParams(formData);
    this.setLoadingMessage('Saving image...');
    return this.callPostEndpoint('content_image/' + id);
  }

  /**
   * Get the image form for editing
   * @param {string} path The route to hit
   * @returns {Observable<any>}
   */
  getEditObject(path: string): Observable<any> {
    this.setLoadingMessage('Getting form...');
    return this.callGetEndpoint(path, false, true);
  }

}


// WEBPACK FOOTER //
// ./src/app/content/shared/services/image-form/image-form-service.ts